import React from 'react';
export function ProblemSection() {
  const problems = ['Sabes que puedes más... pero algo te frena y no sabes exactamente qué es', 'Has leído libros, visto videos, ido a talleres... y sigues sintiéndote igual', 'Hay una decisión que llevas meses — o años — postergando', 'El miedo, la duda o la inseguridad aparecen justo cuando más los necesitas fuera', 'Sientes que tus relaciones, tu dinero o tu carrera no avanzan al ritmo que deberían', 'Te has dicho "voy a cambiar" tantas veces que ya casi no te crees'];
  return <section className="py-20 px-4 bg-white text-[#1a1a2e]" data-id="element-144">
      <div className="max-w-3xl mx-auto" data-id="element-145">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#5B2D8E]" data-id="element-146">
          ¿Te identificas con alguno de estos?
        </h2>

        <ul className="space-y-6 mb-12" data-id="element-147">
          {problems.map((problem, index) => <li key={index} className="flex items-start gap-4 text-lg md:text-xl bg-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm" data-id="element-148">
              <span className="text-2xl shrink-0" data-id="element-149">😔</span>
              <span className="font-medium text-gray-800" data-id="element-150">{problem}</span>
            </li>)}
        </ul>

        <div className="text-center space-y-6 text-lg md:text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-151">
          <p className="font-semibold text-[#1a1a2e]" data-id="element-152">
            Si algo de esto resuena contigo, no es casualidad que estés aquí.
          </p>
          <p data-id="element-153">Y no es un problema de voluntad.</p>
          <p className="font-bold text-[#5B2D8E] text-xl md:text-2xl" data-id="element-154">
            Es que nadie te ha dado la experiencia correcta para romperlo de
            verdad.
          </p>
        </div>
      </div>
    </section>;
}